import React from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, cloneDeep } from 'lodash';

import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';

import ACSaveBar from '../atoms/ACSaveBar';
import ProviderOthers from '../molecules/providers/ProviderOthers';
import ProviderList from '../molecules/providers/ProviderList';
import ProviderDetails from '../molecules/providers/ProviderDetails';
import {
  getProviders,
  getProvider,
  postProvider,
  postCloneProvider,
  patchProvider,
  patchProviderNote,
  putPOIs,
  getProviderLinkedUser,
  deleteProviderLinkedUser,
} from '../common/actions/providers';
import { getItemsByProviderId, postItem, patchItem, bulkDeleteItems, handleItemsScrollPos } from '../common/actions/items';
import { getCluesByProviderId, postClue, patchClue, uploadClue } from '../common/actions/clues';
import { uploadMedia } from '../common/actions/medias';
import {
  getFilterStr,
  getCurrencySymbol,
  getMediaForUIName,
  getUIElementsWithMedias,
  getCurrencySymbolFromCurrencyShortcode,
} from '../common/global';

import styles from './ProvidersPage.module.scss';
import { getDefaultProvider } from '../common/providers';
import { getStoryboardsByProviderId, postStoryboard, patchStoryboard, deleteStoryboard } from 'components/common/actions/storyboards';

// TODO: This screen needs an update to remove componentWillReceiveProps
// If this makes easier, check Spark & Virtual Screen for reference and try divising a flow that way.
class ProvidersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      providers: [],
      provider: {},
      poi: {},
      item: {},
      items: [],
      loadItems: false, // To indicate whether to load all the items from provider after an update has happened
      clue: {},
      clues: [],
      loadClues: false, // To indicate whether to load all the clues from provider after an update has happened

      // Search
      searchText: '',

      // updateData is used to store update data field
      updateData: {},

      // upload data
      uploadClueId: undefined,
      uploadClueDetailType: undefined,

      isRefreshRequired: false,
      refreshClues: false,
      refreshItems: false,

      // Confirmation dialog related states
      openDialog: false,
      selection: {},

      // Alert dialog related states
      openAlertDialog: false,

      storyboards: [],
      storyboard: {},
      loadStoryboards: false,
      loadUsers:false,
      refreshStoryboards: false,
      linkedUsers:[],
      itemsTabScrollPos: null
    };

    this.onChangeSearchText = this.onChangeSearchText.bind(this);
    this.onCreateProvider = this.onCreateProvider.bind(this);
    this.onCopyProvider = this.onCopyProvider.bind(this);
    this.onSelectProvider = this.onSelectProvider.bind(this);
    this.onUpdateProvider = this.onUpdateProvider.bind(this);
    this.onUpdateProviderAddress = this.onUpdateProviderAddress.bind(this);
    this.onSaveProvider = this.onSaveProvider.bind(this);
    this.onSelectItem = this.onSelectItem.bind(this);
    this.onSaveItem = this.onSaveItem.bind(this);
    this.onSelectClue = this.onSelectClue.bind(this);
    this.onSaveClue = this.onSaveClue.bind(this);
    this.onSelectPOI = this.onSelectPOI.bind(this);
    this.onUploadClue = this.onUploadClue.bind(this);

    this.onClickDialogYes = this.onClickDialogYes.bind(this);
    this.onClickDialogNo = this.onClickDialogNo.bind(this);
    this.onClickAlertDialogClose = this.onClickAlertDialogClose.bind(this);

    this.setUnsavedDataFlag = this.setUnsavedDataFlag.bind(this);

    this.onCloneItem = this.onCloneItem.bind(this);

    this.onSavePOIs = this.onSavePOIs.bind(this);

    this.onSelectStoryboard = this.onSelectStoryboard.bind(this);
    this.onSaveStoryboard = this.onSaveStoryboard.bind(this);
    this.onDeleteStoryboard = this.onDeleteStoryboard.bind(this);
    this.updateProviderEnabling = this.updateProviderEnabling.bind(this);
    this.onCloneStoryboard = this.onCloneStoryboard.bind(this);
    this.onBulkDeleteItems = this.onBulkDeleteItems.bind(this);
  }

  providerSelectFields = 'selectFields=true';
  componentDidMount() {
    const { id } = this.props;
    const filterStr = '&'+this.providerSelectFields;
    this.props.getProvidersFunc(filterStr);
    if (id && !isEmpty(id)) {
      this.props.getProviderFunc(id);
      this.props.getItemsByProviderIdFunc(id);
      this.props.getCluesByProviderIdFunc(id);
      this.props.getStoryboardsByProviderIdFunc(id);
      this.props.getProviderLinkedUsersFunc(id);
    }
  }

  componentDidUpdate() {
    if (this.state.loadItems === true) {
      let provider = this.state.provider;
      if (provider) this.props.getItemsByProviderIdFunc(provider.id);
      this.setState({
        loadItems: false,
      });
    }

    if (this.state.loadClues === true) {
      let provider = this.state.provider;
      if (provider) this.props.getCluesByProviderIdFunc(provider.id);
      this.setState({
        loadClues: false,
      });
    }

    if (this.state.loadStoryboards === true) {
      let provider = this.state.provider;
      if (provider){
        this.props.getStoryboardsByProviderIdFunc(provider.id);
        // this.props.getProviderLinkedUsersFunc(provider.id);
      }
      this.setState({
        loadStoryboards: false,
      });
    }

    if (this.state.loadUsers === true) {
      let provider = this.state.provider;
      if (provider){
        this.props.getProviderLinkedUsersFunc(provider.id);
      }
      this.setState({
        loadUsers: false,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.providers &&
      this.props.providers !== nextProps.providers &&
      isEmpty(this.state.updateData)
    ) {
      // Internal update
      this.setState({
        providers: nextProps.providers,

        // Reset updateData
        updateData: {},
      });
    }

    if (nextProps.provider && nextProps.provider !== this.props.provider) {
      // Internal update
      const { provider } = nextProps;
      // extract top media to ease later manipulation
      const medias = provider.medias || [];
      let media = provider.media || { type: 'image', url: '' };
      if (isEmpty(media.url) && !isEmpty(medias)) media = medias[medias.length - 1]; // Pick last element as most probable the latest
      provider.media = media;

      this.setState({
        provider: nextProps.provider,

        // Reset updateData
        updateData: {},
      });
    }

    if (nextProps.pois) {
      let p = cloneDeep(this.state.provider);

      // Internal update
      p.POIs = nextProps.pois;

      this.setState({
        provider: p,
      });
    }

    if (nextProps.items) {
      let is = nextProps.items;

      this.setState({
        items: is,
      });
    } else {
      this.setState({
        items: [],
      });
    }

    if (!nextProps.items) {
      this.setState({
        items: [],
      });
    }

    if (nextProps.itemNewId && nextProps.itemNewId !== this.props.itemNewId) {
      this.setState({
        loadItems: true,
      });
    }

    if (nextProps.clues) {
      let cs = nextProps.clues;

      this.setState({
        clues: cs,
      });
    } else {
      this.setState({
        clues: [],
      });
    }

    if (!nextProps.clues) {
      this.setState({
        clues: [],
      });
    }

    if (nextProps.uploadData) {
      // Internal update
      const { clues = [] } = cloneDeep(this.state);
      let { clue = {} } = cloneDeep(this.state); // This needs to be fixed properly.

      let { details = [] } = clue;

      const detailIndex = details.findIndex((detail) => {
        return detail.type === this.state.uploadClueDetailType;
      });

      if (detailIndex >= 0) {
        let medias = [];
        medias.push({ url: nextProps.uploadData.Location });
        clue.details[detailIndex].medias = medias;
      }

      this.setState({
        clues,
        clue,
      });
    }

    if (nextProps.clueNewId && nextProps.clueNewId !== this.props.clueNewId) {
      let clue = cloneDeep(this.state.clue);
      clue.id = nextProps.clueNewId;
      this.setState({
        loadClues: true,
        clue,
      });
    }

    if (nextProps.filter && nextProps.filter !== this.props.filter &&
      !(
        Object.keys(nextProps.filter).length === 1 &&
        nextProps.filter.hasOwnProperty('bookingDate')
      )
    ) {
      let filterStr = getFilterStr(nextProps.filter);
      filterStr += '&'+this.providerSelectFields;
      this.props.getProvidersFunc(filterStr);

      this.setState({
        providers: [],
        provider: {},
        updateData: {},
      });
    }

    if (nextProps.newId && nextProps.newId !== this.props.newId) {
      const provider = cloneDeep(this.state.provider);
      provider.id = nextProps.newId;
      this.setState({
        provider,
      });

      let providers = [...this.state.providers];
      // Update internal providers
      if (providers) {
        let updatedProviders = providers.map((p) => {
          let provider = p;
          if (provider.id) {
            if (provider.id === '') provider.id = nextProps.newId;
          } else {
            provider.id = nextProps.newId;
          }
          console.log('update id', provider);
          return provider;
        });
        this.setState({
          providers: updatedProviders,
          items: [],
          clues: [],
          storyboards: [],
        });
      }
    }

    if (nextProps.storyboards) {
      let is = nextProps.storyboards;

      this.setState({
        storyboards: is,
      });
    } else {
      this.setState({
        storyboards: [],
      });
    }

    if (!nextProps.storyboards) {
      this.setState({
        storyboards: [],
      });
    }

    if (nextProps.storyboardNewId && nextProps.storyboardNewId !== this.props.storyboardNewId) {
      this.setState({
        loadStoryboards: true,
      });
    }

    if (nextProps.poiUploadUrl && nextProps.poiUploadUrl !== this.props.poiUploadUrl) {
      const { poi } = cloneDeep(this.state);
      let { medias = [] } = poi;
      medias.push({ url: nextProps.poiUploadUrl });
      poi.medias = medias;
      this.setState({ poi });
    }

    if (nextProps.isRefreshRequired && nextProps.provider.id) {
      this.setState({
        provider : nextProps.provider,

        // Reset updateData
        updateData: {},

        // Reset items and clues since selection has been changed
        items: [],
        clues: [],
        isSaving : false,
        storyboards: [],
      }, () => {
        this.props.getProviderFunc(this.state.provider.id);
        this.props.getItemsByProviderIdFunc(this.state.provider.id);
        this.props.getCluesByProviderIdFunc(this.state.provider.id);
        this.props.getStoryboardsByProviderIdFunc(this.state.provider.id);
      });
    }
    if (nextProps.refreshClues && nextProps.provider.id) {
        console.log('Refresh Clues')
        this.setState({ clues: [], isSaving : false }, () => {
            this.props.getCluesByProviderIdFunc(nextProps.provider.id);
        })
    }
    if (nextProps.refreshItems && nextProps.provider.id) {
        console.log('Refresh Items')
        this.setState({ items: [], isSaving : false}, () => {
            this.props.getItemsByProviderIdFunc(nextProps.provider.id);
        })
    }
    if (nextProps?.refreshStoryboards && nextProps?.provider?.id) {
        console.log('Refresh Storyboards')
        this.setState({ storyboards: [], isSaving : false}, () => {
            this.props.getStoryboardsByProviderIdFunc(nextProps.provider.id);
        })
    }

  }



  handleSearchDebounced = _.debounce(() => {
    const searchText = this.state.searchText;
    // console.log({ handleSearchDebounced : searchText})
    const filters = {...this.props.filters};
    filters['providerName'] = encodeURIComponent(searchText);
    let filterStr = getFilterStr(filters);
    filterStr += '&'+this.providerSelectFields;
    this.props.getProvidersFunc(filterStr);
  }, 500);

  onChangeSearchText =(event) => {
    const searchText = event.target.value;
    // console.log({onChangeSearchText : searchText});
    this.setState({
      searchText,
    });
    this.handleSearchDebounced(searchText);
  }


  onBulkDeleteItems(items) {
    this.props.bulkDeleteItemsFunc(items);
  }


  onCreateProvider() {
    // Internal update
    let ps = [...this.state.providers];
    let updateData = {};

    // This indicates there is already an unsaved provider
    let found = ps.find((p) => {
      return !p.id || p.id === '';
    });
    if (found) return;

    let newProvider = getDefaultProvider();
    // newProvider.name = 'Provider Name';
    newProvider.id = '';

    // updateData.name = 'Provider Name';
    updateData.status = 'active';
    updateData.settings = cloneDeep(newProvider.settings);
    updateData.media = cloneDeep(newProvider.media);
    ps.push(newProvider);

    this.setState({
      providers: ps,
      provider: newProvider,
      updateData: updateData,
      items: [],
      item: {},
      clues: [],
      clue: {},
      storyboards: [],
      storyboard: {},
    });
    this.setUnsavedDataFlag(updateData);
  }

  onCopyProvider(provider) {
    const searchText = this.state.searchText;
    // console.log({ handleSearchDebounced : searchText})
    const filters = {...this.props.filters};
    filters['providerName'] = encodeURIComponent(searchText);
    let filterStr = getFilterStr(filters);
    this.props.postCloneProviderFunc(provider, filterStr);
    this.setState({
      provider : {},
      updateData: {},
  });
  }

  onSelectProvider(provider) {
    console.log('provider', provider);

    if (!isEmpty(this.state.updateData)) {
      this.setState({
        openDialog: true,
        selection: provider,
      });
      return;
    }

    // Internal update
    this.setState({
      provider,

      // Reset updateData
      updateData: {},

      // Reset items and clues since selection has been changed
      items: [],
      clues: [],
      storyboards: [],
    });
    this.props.getProviderFunc(provider.id)
    this.props.getItemsByProviderIdFunc(provider.id);
    this.props.getCluesByProviderIdFunc(provider.id);
    this.props.getStoryboardsByProviderIdFunc(provider.id);
    this.props.getProviderLinkedUsersFunc(provider.id);
  }

  onClickDialogYes() {
    this.resetUnSavedDataFlag();
    this.setState(
      {
        openDialog: false,
        // Reset updateData
        updateData: {},
      },
      // Callback function has been used to make the selection,
      // if the user decides to leave the changes.
      () => {
        this.onSelectProvider(this.state.selection);
      }
    );
  }

  onClickDialogNo() {
    this.setState({
      openDialog: false,
    });
  }

  onClickAlertDialogClose() {
    this.setState({
      openAlertDialog: false,
    });
  }

  onUpdateProviderAddress(whereValue) {
    // Internal Update
    let ps = [...this.state.providers];
    let p = cloneDeep(this.state.provider);
    let ud = cloneDeep(this.state.updateData);

    p.where = whereValue;

    if (!ud.where) ud.where = {};
    ud.where.address = whereValue.address;

    ps.forEach((newP) => {
      if (newP.id === p.id) {
        newP = p;
      }
    });

    this.setState({
      providers: ps,
      provider: p,
      updateData: ud,
    });
  }

  updateProviderEnabling(id,value){
    const body = {
      id:id,
      enablingStoryboard:value
    }
    this.props.patchProviderFunc(body);
  }

  onUpdateProvider(key, value) {
    // Internal Update
    let ps = cloneDeep(this.state.providers);
    let p = cloneDeep(this.state.provider);
    let ud = cloneDeep(this.state.updateData);
    p[key] = value;
    ud[key] = value;
    ps.forEach((newP) => {
      if (newP.id === p.id) {
        newP[key] = value;
      }
    });

    this.setState({
      providers: ps,
      provider: p,
      updateData: ud,
    });
  }

  onSaveProvider() {
    // External update
    let ud = cloneDeep(this.state.updateData);

    if (isEmpty(ud) || !this.state.provider) return;
    if (this.state.provider.id) ud.id = this.state.provider.id;
    if (ud.whens) {
      let ws = [];
      ud.whens.forEach((when) => {
        if (when && when.from && when.to) ws.push(when);
      });

      ud.whens = ws;
    }

    const { uiElements = [], media = { url: '' }, medias = [] } = ud;
    if (!isEmpty(uiElements)) ud.uiElements = getUIElementsWithMedias(uiElements);

    if (!isEmpty(media.url)) {
      medias.push(cloneDeep(media));
      delete ud.media;
      ud.medias = medias;
    }

    if (ud.id) {
      // Note
      if (!isEmpty(ud.note)) {
        const note = Object.assign(
          {},
          {
            private: ud.note.private,
            public: ud.note.public,
            provider: ud.note.provider,
            internalAdditional: ud.note.internalAdditional,
          }
        );
        this.props.patchProviderNoteFunc(ud.id, note);
        delete ud.note;
      }

      // Other changes
      if (Object.keys(ud).length > 1) {
        this.props.patchProviderFunc(ud);
      }
    } else {
      if (!ud.name) {
        this.setState({
          openAlertDialog: true,
        });
        return;
      }
      this.props.postProviderFunc(ud);
    }

    this.setState({
      updateData: {},
    });

    this.resetUnSavedDataFlag();
    this.onBlockingScreenWhenSaving();
  }

  getProviderMedias(media) {
    const { url = '' } = media;
    if (!isEmpty(url)) {
    }
  }

  onSelectItem(item) {
    console.log('item', item);

    // Internal update
    this.setState({
      item,
      itemsTabScrollPos: this.props.itemScrollPos
    });
  }

  onSaveItem(item) {
    // External update
    if (isEmpty(item)) return;

    const { uiElements = [], media = { url: '' }, medias = [] } = item;
    if (!isEmpty(uiElements)) item.uiElements = getUIElementsWithMedias(uiElements);

    if (!isEmpty(media.url)) {
      medias.push(cloneDeep(media));
      delete item.media;
      item.medias = medias;
    }

    item.providerId = this.state.provider.id;
    if (item.id) {
      this.props.patchItemFunc(item);
    } else {
      this.props.postItemFunc(item);
    }

    // Internal update
    let is = [...this.state.items];

    let found = false;
    for (let i = 0; i < is.length; i++) {
      if (is[i].id === item.id) {
        is[i] = item;
        found = true;
      }
    }

    if (!found) {
      is.push(item);
    }

    this.setState({
      item: item,
      items: is,
    });

    this.onBlockingScreenWhenSaving();
  }

  onSelectClue(clue) {
    console.log('clue', clue);

    // Internal update
    this.setState({
      clue,
    });
  }

  onSaveClue(clue) {
    // External update
    if (isEmpty(clue)) return;

    clue.providerId = this.state.provider.id;
    if (clue.id) {
      this.props.patchClueFunc(clue);
    } else {
      this.props.postClueFunc(clue);
    }

    // Internal update
    let cs = [...this.state.clues];
    let found = false;

    for (let i = 0; i < cs.length; i++) {
      if (cs[i].id === clue.id) {
        cs[i] = clue;
        found = true;
      }
    }

    if (!found) {
      cs.push(clue);
    }

    this.setState({
      clue: clue,
      clues: cs,
    });

    this.onBlockingScreenWhenSaving();
  }

  onSelectPOI(poi) {
    console.log('poi', poi);

    // Internal update
    this.setState({
      poi,
    });
  }

  onSavePOIs(pois = []) {
    const { providers, provider } = cloneDeep(this.state);

    // Strip off the index as it is just for helping some functions like swap, updation in the array without iterating.

    pois.forEach((poi) => {
      delete poi.index;
    });

    provider.POIs = cloneDeep(pois);
    providers.forEach((p) => {
      if (p.id === provider.id) {
        p.POIs = cloneDeep(pois);
      }
    });

    this.props.putPOIsFunc(provider.id, pois);
    this.setState({
      providers,
      provider,
    });

    this.onBlockingScreenWhenSaving();
  }

  onSelectStoryboard(storyboard) {
    console.log('storyboard', storyboard);

    // Internal update
    this.setState({
      storyboard: storyboard,
    });
  }
  
  onSaveStoryboard(storyboard) {
    // External update
    if (isEmpty(storyboard)) return;

    const { uiElements = [], media = { url: '' }, medias = [] } = storyboard;
    if (!isEmpty(uiElements)) storyboard.uiElements = getUIElementsWithMedias(uiElements);

    if (!isEmpty(media.url)) {
      medias.push(cloneDeep(media));
      delete storyboard.media;
      storyboard.medias = medias;
    }

    storyboard.providerId = this.state.provider.id;
    console.log("provider page storyboard", storyboard)
    if (storyboard.id) {
      this.props.patchStoryboardFunc(storyboard);
    } else {
      this.props.postStoryboardFunc(storyboard);
    }

    // Internal update
    let is = [...this.state.storyboards];

    let found = false;
    for (let i = 0; i < is.length; i++) {
      if (is[i].id === storyboard.id) {
        is[i] = storyboard;
        found = true;
      }
    }

    if (!found) {
      is.push(storyboard);
    }

    this.setState({
      storyboard: storyboard,
      storyboards: is,
    });

    this.onBlockingScreenWhenSaving();
  }

  onDeleteStoryboard(storyboardId) {
    if (isEmpty(storyboardId)) return;
   
    if (storyboardId) {
      this.props.deleteStoryboardFunc(storyboardId);
    }

    this.onBlockingScreenWhenSaving();
  }

  onCloneStoryboard(storyboardId){
    if(!storyboardId) return;

    const {storyboards}= this.state;
    const cloningStoryboard = storyboards.find((storyboard)=>storyboard.id===storyboardId);
    if(!isEmpty(cloningStoryboard)){
      if(cloningStoryboard.name) cloningStoryboard.name = `Copy of ${cloningStoryboard.name}`;
      if(cloningStoryboard.internalNote) cloningStoryboard.internalNote = `Copy - ${cloningStoryboard.internalNote}`;
      delete cloningStoryboard.id;
      this.props.postStoryboardFunc(cloningStoryboard);
    }
  }

  setUnsavedDataFlag(unsavedData) {
    if (!isEmpty(unsavedData)) this.props.setUnsavedDataFlagFunc(true);
  }

  resetUnSavedDataFlag() {
    this.props.setUnsavedDataFlagFunc(false);
  }

  onUploadClue(id, detailType, fileList, internalClue) {
    console.log('before upload', internalClue);
    this.setState({
      uploadClueId: id,
      uploadClueDetailType: detailType,
      clue: internalClue,
    });

    this.props.onUploadClueFunc(fileList);
  }

  onCloneItem(objItem) {
    const item = cloneDeep(objItem);
    if (item.id) delete item.id;
    this.onSaveItem(item);
  }

  // FIXME: Delay just as temp fix for now
  onBlockingScreenWhenSaving = (delay = 7000) => {
    this.setState({
      isSaving: true,
    });

    setTimeout(() => {
      this.setState({
        isSaving: false,
      });
    }, delay);
  };

  renderAlertDialog(alertText) {
    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Alert
          </DialogTitle>
          <DialogContent>
            <DialogContentText>{alertText}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderConfirmDialog() {
    return (
      <div>
        <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Confirm
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The data has not been saved yet. Are you sure to leave?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickDialogYes} color="primary">
              Yes
            </Button>
            <Button onClick={this.onClickDialogNo} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  // TODO: 3 dialogs can be combined
  renderProgressDialog = () => {
    return (
      <div>
        <Dialog open={this.state.isSaving} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Please wait...
          </DialogTitle>
          <DialogContent>
            <center>
              <CircularProgress />
            </center>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  render() {

    const provider = this.state.provider;
    const { providerMedia = {}, itemMedia = {}, poiMedia = {}, storyboardMedia = {} } = this.props;
    const pois = provider.POIs;
    let currencySymbol = '$';

    if (provider && !isEmpty(provider)) {
      if (provider.where && !isEmpty(provider.where)) {
        const { where } = provider;
        currencySymbol = getCurrencySymbol(where.country || '');
      }
    }
    let providers = this.state.providers;

    let components = [
      <div className={styles.left} key="providerList-key">
        <ProviderList
          searchText={this.state.searchText}
          providers={providers}
          provider={this.state.provider}
          onChangeSearchTextFunc={this.onChangeSearchText}
          onCreateProviderFunc={this.onCreateProvider}
          onSelectProviderFunc={this.onSelectProvider}
        />
      </div>,
    ];

    if (!isEmpty(this.state.provider)) {
      if(this.state.provider.settings && this.state.provider.settings.currency) {
        const currency = this.state.provider.settings.currency;
        currencySymbol = getCurrencySymbolFromCurrencyShortcode(currency)
      }
      components.push(
        <div
          className={styles.center}
          onBlur={() => this.setUnsavedDataFlag(this.state.updateData)}
        >
          <ProviderDetails
            onCopyProviderFunc={this.onCopyProvider}
            onUpdateProviderFunc={this.onUpdateProvider}
            onUpdateProviderAddressFunc={this.onUpdateProviderAddress}
            onSaveStoryboardFunc={this.onSaveStoryboard}
            onSavePOIsFunc ={this.onSavePOIs}
            provider={this.state.provider}
            getProviderFunc={this.props.getProviderFunc}
            onUpdateProviderStoryboard ={this.updateProviderEnabling}
            media={providerMedia}
            uploadMediaFunc={this.props.uploadMediaFunc}
          />
        </div>
      );

      components.push(
        <div className={styles.right}>
          <ProviderOthers
            providerId={provider.id || 'undefined'}
            provider = {provider ?? {}}
            isEnabledStoryboard = {provider.enablingStoryboard}
            item={this.state.item}
            items={this.state.items}
            clue={this.state.clue}
            clues={this.state.clues}
            poi={this.state.poi}
            pois={pois}
            storyboard={this.state.storyboard}
            storyboards={this.state.storyboards}
            onSelectStoryboardFunc={this.onSelectStoryboard}
            onSaveStoryboardFunc={this.onSaveStoryboard}
            onDeleteStoryboardFunc={this.onDeleteStoryboard}
            onCloneStoryboardFunc={this.onCloneStoryboard}
            storyboardMedia={storyboardMedia}
            currencySymbol={currencySymbol}
            onSelectItemFunc={this.onSelectItem}
            onSaveItemFunc={this.onSaveItem}
            onSelectClueFunc={this.onSelectClue}
            onSaveClueFunc={this.onSaveClue}
            onSelectPOIFunc={this.onSelectPOI}
            onUploadClueFunc={this.onUploadClue}
            onCloneItemFunc={this.onCloneItem}
            onSavePOIsFunc={this.onSavePOIs}
            onBulkDeleteItemsFunc={this.onBulkDeleteItems}
            onUploadPOIMediaFunc={this.onUploadPOIMedia}
            onClearPOIMediaFunc={this.onClearPOIMedia}
            itemMedia={itemMedia}
            poiMedia={poiMedia}
            uploadMediaFunc={this.props.uploadMediaFunc}
            linkedUsers={this.props.linkedUsers}
            getProviderLinkedUsersFunc={this.props.getProviderLinkedUsersFunc}
            deleteProviderLinkedUserFunc={this.props.deleteProviderLinkedUserFunc}
            bulkDeleteInProgress={this.props.bulkDeleteInProgress}
            providerItemsScrollPosFunc={this.props.providerItemsScrollPosFunc}
            itemScrollPos={this.state.itemsTabScrollPos}
            isSaving={this.state.isSaving}
          />
        </div>
      );
    }
    const isEnabled = !isEmpty(this.state.updateData) 
    // && !this.state.updateData.enablingStoryboard;

    return (
      <div className={styles.root}>
        <ACSaveBar isEnabled={isEnabled} onSaveFunc={this.onSaveProvider} />
        {components}
        {this.renderConfirmDialog()}
        {this.renderAlertDialog('Please enter a provider name to save.')}
        {this.renderProgressDialog()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getProvidersFunc: (filterParams) => dispatch(getProviders(filterParams)),
    getProviderFunc: (providerId) => dispatch(getProvider(providerId)),
    getItemsByProviderIdFunc: (providerId) => dispatch(getItemsByProviderId(providerId)),
    getCluesByProviderIdFunc: (providerId) => dispatch(getCluesByProviderId(providerId)),

    postProviderFunc: (provider) => dispatch(postProvider(provider)),
    postCloneProviderFunc: (provider, searchText) => dispatch(postCloneProvider(provider, searchText)),
    postItemFunc: (item) => dispatch(postItem(item)),
    postClueFunc: (item) => dispatch(postClue(item)),

    patchProviderFunc: (provider) => dispatch(patchProvider(provider)),
    patchProviderNoteFunc: (providerId, note) => dispatch(patchProviderNote(providerId, note)),
    patchItemFunc: (item) => dispatch(patchItem(item)),
    patchClueFunc: (clue) => dispatch(patchClue(clue)),

    bulkDeleteItemsFunc: (items) => dispatch(bulkDeleteItems(items)),
    providerItemsScrollPosFunc: (pos) => dispatch(handleItemsScrollPos(pos)),

    putPOIsFunc: (providerId, pois) => dispatch(putPOIs(providerId, pois)),
    onUploadClueFunc: (fileList) => dispatch(uploadClue(fileList)),

    uploadMediaFunc: (mediaFor, mediaType, file) =>
      dispatch(uploadMedia(mediaFor, mediaType, file)),

    getStoryboardsByProviderIdFunc: (providerId) => dispatch(getStoryboardsByProviderId(providerId)),
    postStoryboardFunc: (storyboard) => dispatch(postStoryboard(storyboard)),
    patchStoryboardFunc: (storyboard) => dispatch(patchStoryboard(storyboard)),
    deleteStoryboardFunc: (storyboardId) => dispatch(deleteStoryboard(storyboardId)),
    getProviderLinkedUsersFunc:(providerId)=>dispatch(getProviderLinkedUser(providerId)),
    deleteProviderLinkedUserFunc:(providerId,userDetails)=>dispatch(deleteProviderLinkedUser(providerId,userDetails))
  };
};

const mapStateToProps = (state) => {
  const stateProviders = state.providers;
  const stateItems = state.items;
  const stateClues = state.clues;
  const stateMedias = state.medias || {};
  const stateStoryboards = state.storyboards;

  const { media = {} } = stateMedias;
  const { ui = '' } = media;
  const providerMedia = ui === getMediaForUIName().provider ? media : {};
  const itemMedia = ui === getMediaForUIName().item ? media : {};
  const poiMedia = ui === getMediaForUIName().poi ? media : {};
  const storyboardMedia = ui === getMediaForUIName().storyboard ? media : {};

  let providers;
  let provider;
  let pois;
  let newId;
  let items;
  let clues;
  let uploadData;
  let isRefreshRequired;
  let poiUploadUrl;
  let refreshClues;
  let refreshItems;
  let storyboards;
  let refreshStoryboards;
  let linkedUsers;
  let bulkDeleteInProgress;
  let itemScrollPos;

  let itemNewId, clueNewId, storyboardNewId;

  if (stateProviders) {
    isRefreshRequired = stateProviders.isRefreshRequired;

    if (stateProviders.error) {
      console.log(stateProviders.error.message);
    }
    if (stateProviders.providers) {
      providers = stateProviders.providers.data;
    }
    if (stateProviders.provider) {
      provider = stateProviders.provider.data;
    }
    if (stateProviders.newId) {
      newId = stateProviders.newId;
    }
    if (stateProviders.pois) {
      pois = stateProviders.pois.data;
    }
    if(stateProviders.LinkedUsers){
      linkedUsers=stateProviders.LinkedUsers.data
      ||[];
    }
    poiUploadUrl = stateProviders.poiUploadUrl || '';
  }

  if (stateItems) {
    refreshItems = stateItems.isRefreshRequired;
    bulkDeleteInProgress = stateItems.bulkDeleteInProgress;
    if (stateItems.error) {
      console.log(stateItems.error.message);
    }
    if (stateItems.items) {
      items = stateItems.items.data;
      console.log('items', items);
    }
    if (stateItems.newId) {
      itemNewId = stateItems.newId.data;
    }
    if(stateItems.scrollPos) {
      itemScrollPos = stateItems.scrollPos;
    }
  }

  if (stateClues) {
    refreshClues = stateClues.isRefreshRequired;
    if (stateClues.newId) {
      clueNewId = stateClues.newId.data;
    }
    if (stateClues.error) {
      console.log(stateClues.error.message);
    }
    if (stateClues.clues) {
      if (stateClues.clues.data) {
        clues = stateClues.clues.data;
        console.log('clues', clues);
      }

      if (stateClues.clues.uploadData) {
        uploadData = stateClues.clues.uploadData;
        console.log('File has been uploaded to:', uploadData.Location);
      }
    }
  }

  if (stateStoryboards) {
    refreshStoryboards = stateStoryboards.isRefreshRequired;
    if (stateStoryboards.error) {
      console.log(stateStoryboards.error.message);
    }
    if (stateStoryboards.storyboards) {
      storyboards = stateStoryboards.storyboards.data;
      console.log('storyboards', storyboards);
    }
    if (stateStoryboards.newId) {
      storyboardNewId = stateStoryboards.newId.data;
    }
  }

  return {
    providers,
    provider,
    pois,
    newId,
    items,
    clues,
    uploadData,
    itemNewId,
    clueNewId,
    isRefreshRequired,
    refreshClues,
    refreshItems,
    poiUploadUrl,
    providerMedia,
    itemMedia,
    poiMedia,
    storyboards,
    storyboardNewId,
    refreshStoryboards,
    storyboardMedia,
    linkedUsers,
    bulkDeleteInProgress,
    itemScrollPos
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProvidersPage);
